import { subclass } from "esri/core/accessorSupport/decorators";
import { tsx } from "esri/widgets/support/widget";
import Widget = require("esri/widgets/Widget");
import json = require("../../package.json");
import * as layerSource from "../data/Layers/layerSource";
import {signIn, logout, authLoggedIn, loggedInAccount, authIsPrivileged, authIsInternal} from '../widgets/App/setupView';
import Query = require("esri/rest/support/Query");
import QueryTask = require("esri/rest/query");

const CSS = {
  base: "info-widget"
};

@subclass("esri.widgets.Info")
class Info extends Widget {
  static roadDate = "";
  static nightlyRoadDate = "";
  static yearEndRoadDate = "";
  static structureDate = "";
  featureUpdateTable = new Map();

  constructor() {
    super();
  }

  // -------------------------------------------------------------------
  //
  //  Public methods
  //
  // -------------------------------------------------------------------

  queryFeatureTable() {
    // console.log("Info queryFeatureTable");
    try {
      let queryUrl = layerSource.serverUrl + "/" + layerSource.FeatureUpdateLayer.toString();

      QueryTask.executeQueryJSON(queryUrl, {  // autocasts as new Query()
        outFields: ["*"],
        where: "1=1"
      }).then(results => {
          if (results && results.features && results.features.length > 0) {
            results.features.forEach(feature => {
              const tableName = feature.attributes.TableName;
              const category = feature.attributes.Category;
              const description = feature.attributes.Description;
              const dataDate = feature.attributes.DataDate;
              const key = tableName + "|" + category + "|" + description;
              this.featureUpdateTable.set(key, dataDate);
            });
            Info.structureDate = this.featureUpdateTable.get("STRUCTURES|Structure|IDOT Inventory Stucture"); 
            Info.nightlyRoadDate = this.featureUpdateTable.get("ROADS|Roadway|IDOT Inventory Roadway");
            Info.yearEndRoadDate = this.featureUpdateTable.get("YEAR END|Roadway|IDOT Inventory Roadway - Year End");

            if (authLoggedIn) {
              Info.roadDate = Info.nightlyRoadDate; 
            } else {
              Info.roadDate = Info.yearEndRoadDate; 
            }
          }
        })
        .catch(error => {
          console.error("Error in featureUpdateLayer", error);
        });
    } catch (error) {
      console.error(" error in featureUpdateTable query", error);
    }
  }

  render() {
    return (
      <div class={CSS.base}>
        <div class="info-box">
          <div class="info-column info-left">
            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="info-button activeBtn"
                  value="Metadata"
                  id="btnMetadata"
                  bind={this}
                  onclick={this._infoBtn}
                />
              </div>
            </div>

            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="info-button"
                  value="Disclaimer"
                  id="btnDisclaimer"
                  bind={this}
                  onclick={this._infoBtn}
                />
              </div>
            </div>

            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="info-button"
                  value="Links"
                  id="btnLinks"
                  bind={this}
                  onclick={this._infoBtn}
                />
              </div>
            </div>

            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="info-button"
                  value="Help"
                  id="btnHelp"
                  bind={this}
                  onclick={this._infoBtn}
                />
              </div>
            </div>


            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="info-button"
                  value="Login"
                  id="btnLogin"
                  bind={this}
                  onclick={this._infoBtn}
                />
              </div>
            </div>


            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="info-button"
                  value="About"
                  id="btnAbout"
                  bind={this}
                  onclick={this._infoBtn}
                />
              </div>
            </div>
          </div>
          <div class="info-column info-right">
            <div class="info-content" id="contentInfo" />
          </div>
        </div>
      </div>
    );
  }

  init() {
    // console.log("info init");
    const div = document.getElementById("btnMetadata") as HTMLInputElement;
    div.click();
  }

  setAuthButton() {
    // console.log("setAuthButton");
    const isPrivileged = document.getElementById("privilegedUser") as HTMLSpanElement;
    isPrivileged.innerText = (authLoggedIn && authIsPrivileged ? "Privileged" : (authLoggedIn && authIsInternal ? "Internal" : "Public"));
    isPrivileged.style.fontWeight = "bold";

    const authButton = document.getElementById("authButton") as HTMLInputElement;
    if (authButton) {
      const accountName = document.getElementById("accountName") as HTMLInputElement;
      const accountEmail = document.getElementById("accountEmail") as HTMLInputElement;
      const accountIsPrivileged = document.getElementById("accountIsPrivileged") as HTMLInputElement;

      authButton.onclick = this.authButtonClick;
      
      if (authLoggedIn) {
        authButton.value = "Logout";
        accountName.innerText = "Name : " + loggedInAccount.name;
        accountEmail.innerText = "Email : " + loggedInAccount.idTokenClaims.email;
        accountIsPrivileged.innerText = "Access : " + (authIsPrivileged ? "Privileged" : (authIsInternal ? "Internal" : "Public"));
      } else {
        authButton.value = "Login";
        accountName.innerText = "Name : ";
        accountEmail.innerText = "Email : ";
        accountIsPrivileged.innerText = "Access : Public"
      }
    }
  }
  
  private _infoBtn(event: MouseEvent) {
    // console.log("Button press", event);
    let btnName = "btnMetadata";
    if (event.srcElement) {
      btnName = (event.srcElement as HTMLElement).id;
    }
    // console.log("btnName = ", btnName);

    const buttons = document.getElementsByClassName("info-button");
    if (buttons) {
      for (let i = 0; i < buttons.length; i++) {
        if (buttons[i]) {
          buttons[i].className = buttons[i].className.replace(" activeBtn", "");
          if (buttons[i].id === btnName) {
            buttons[i].className += " activeBtn";
          }
        }
      }
    }

    let html = "";
    switch (btnName) {
      case "btnMetadata":
        html =
          "<h3>Metadata</h3>" +
          "<h4>Program Planning Systems Published Data:</h4>" +
          "<p>" +
          "- Annual data current as of " +
          this.featureUpdateTable.get("PUBLISHEDANNROADWAY|Program Planning|Annual") +
          "</br>" +
          "- For the Record data current as of " +
          this.featureUpdateTable.get("PUBLISHEDFTRROADWAY|Program Planning|For the Record") +
          "<br>" +
          "- Multi-Year data current as of " +
          this.featureUpdateTable.get("PUBLISHEDMYPROADWAY|Program Planning|Multi-Year") +
          "<br></p>" +
          "<h4>Road Condition Data (CRS, IRI, RUT):</h4>" +
          "<p>" +
          "- Interstate data as of " +
          this.featureUpdateTable.get("CRS|Road Condition Data|Interstate") +
          "</br>" +
          "- Cook County and District 4-5-8-9 as of " +
          this.featureUpdateTable.get("CRS|Road Condition Data|Cook County and District 4-5-8-9") +
          "</br>" +
          "- Collar Counties and District 2-3-6-7 as of " +
          this.featureUpdateTable.get("CRS|Road Condition Data|Collar Counties and District 2-3-6-7") +
          "</br></p>" +
          "<h4>Road Condition Van Pictures:</h4>" +
          "<p>" +
          "- Interstate data as of " +
          this.featureUpdateTable.get("VanPicture|Road Condition Van Pictures|Interstate") +
          "</br>" +
          "- Cook County and District 4-5-8-9 as of " +
          this.featureUpdateTable.get("VanPicture|Road Condition Van Pictures|Cook County and District 4-5-8-9") +
          "</br>" +
          "- Collar Counties and District 2-3-6-7 as of " +
          this.featureUpdateTable.get("VanPicture|Road Condition Van Pictures|Collar Counties and District 2-3-6-7") +
          "</br></p>" +
          "<h4>IDOT Inventory Data:</h4>" +
          "<p>" +
          "- Roadway data as of " + Info.roadDate +
          "</br>" +
          "- Structure data current as of " +
          this.featureUpdateTable.get("STRUCTURES|Structure|IDOT Inventory Stucture") +
          "</br>" +
          "- Functional Class as of " +
          this.featureUpdateTable.get("ROADS|Functional Class|IDOT Inventory Functional Class") +
          "</br></p>";
        break;
      case "btnDisclaimer":
        html =
          "<center>" +
          "<h3>Disclaimer</h3>" +
          "<br>" +
          "<p>The purpose of this program is a quick reference tool.</p>" +
          "<p>For additional or more detailed information,</p>" +
          "<p>refer to the actual data sources such as IRIS,</p>" +
          "<p>the published programs, ISIS, et al.</p>" +
          "</center>";
        break;
      case "btnLinks":
        html =
          "<h3>ICC Railroad Crossings Link</h3>" +
          "<a href='https://www.icc.illinois.gov/rail-safety/grade-crossing-map' target='_blank'>Illinois Commerce Commission Railroad Crossings</a>" +
          "<br>" +
          "<h3>Office of Program and Planning</h3>" +
          "<a href='https://idot.illinois.gov/travel-and-maps/roadways.html' target='_blank'>Bureau of Programming - Highway System & Statistics</a><br><br>" +
          "<a href='https://idot.illinois.gov/transportation-system/transportation-management/transportation-improvement-programs.html' target='_blank'>Bureau of Programming - Highway Improvement Programs</a><br><br>" +
          "<a href='https://idot.illinois.gov/travel-and-maps/highway-maps.html' target='_blank'>Highway Maps</a>";
        break;
      case "btnHelp":
        html =
          "<h3>IROADS Support</h3>" +
          "<a href='mailto:DOT.IRoadsSupport@illinois.gov' target='_blank'>Contact IRoads Support</a>" +
          "<br>" +
          "<h3>Reference Guide</h3>" +
          "<a href='./assets/Illinois Roadway Analysis Database System.pdf' target='_blank'>View Help file</a>";
        break;
      case "btnLogin":
        html =
          "<H3>IROADS - Privileged Access</H3>" +
          "<p>Qualified users can log in to obtain privileged access.</p>" +
          "<p>Only users who have been, or need, privileged access should log in.</p>" +
          "<p>When you first log in, your account will be verified.</p><br>" +
          "<h4 id='accountName'>Name : <h4>" + 
          "<h4 id='accountEmail'>Email : </h4>" +
          "<h4 id='accountIsPrivileged'>Access : </h4><br>" +
          "<p>" +
          "<input type='button' class='mask-button' style='height:30px;width:100px;font-size:18px;font-weight:bold;' value='Login' id='authButton'/>" + 
          "</p>";
        break;

      case "btnAbout":
        html =
          "<center>" +
          "<img src='./assets/idot_logo.png'/>" +
          "<H3>ILLINOIS DEPARTMENT OF TRANSPORTATION</H3>" +
          "<H3>IROADS - Illinois Roadway Analysis Database System</H3>" +
          "<p>Version " +
          json.version +
          "</p>" +
          "<p>Developed at the Illinois Dept. of Transportation</p>" +
          "<p>by Bureau of Information Processing.</p>" +
          "</center>";
        break;

      default:
        break;
    }

    const div = document.getElementById("contentInfo") as HTMLDivElement;
    div.textContent = "";
    div.innerHTML = html;

    this.setAuthButton();
  }
  
  private authButtonClick() {
    const authButton = document.getElementById("authButton") as HTMLInputElement;
    // console.log("authButtonClick");
    if (authButton.value.substr(0,5) === "Login") {
      signIn();
    } else {
      logout();
    }
  }
  

}



export = Info;
